import React from 'react';

// Design System Components
import TextField from 'Components/DesignSystem/TextField/TextField';

// Module Components
import SectionHeading from './SectionHeading';

// Constants
import { MAX_DISPLAY_LABEL_LENGTH, STRINGS } from '../../../constants';

interface LabelSectionProps {
  /** The element's short name — the placeholder reads `e.g. <panel name>` (R43). */
  panelName: string;
  displayLabel: string;
  onDisplayLabelChange: (displayLabel: string) => void;
}

/**
 * The Label section of a field's properties panel: free text, and blank hides the
 * label on the card (spec R43, R66).
 *
 * The copy is the prototype's, which the operator's round-4 request named
 * explicitly: the heading "Label", the caption "Display label (blank = none)", and a
 * per-element placeholder — "e.g. Title", "e.g. SKU", "e.g. List price". That
 * supersedes ticket 11988's single "Leave blank to hide the label" placeholder, since
 * the caption now carries the blank-means-none instruction instead.
 */
const LabelSection = ({
  panelName,
  displayLabel,
  onDisplayLabelChange,
}: LabelSectionProps) => (
  <div className="tw-flex tw-flex-col tw-gap-2 tw-px-3 tw-py-3 tw-border-b tw-border-edge">
    <SectionHeading as="h4">{STRINGS.pane.labelSectionTitle}</SectionHeading>
    <TextField
      label={STRINGS.pane.displayLabel}
      placeholder={`${STRINGS.pane.displayLabelPlaceholderPrefix}${panelName}`}
      value={displayLabel}
      onChange={onDisplayLabelChange}
      maxLength={MAX_DISPLAY_LABEL_LENGTH}
      labelSize="sm"
    />
  </div>
);

export default LabelSection;
